import React from 'react';
import { useHistory, useLocation } from 'react-router';

import { Box, Card, CardContent, List, Typography } from '@material-ui/core';

import { useStyles } from './styles';
import PaymentItem from './PaymentItem';

export function FormasPagamento() {
  const classes = useStyles();

  const history = useHistory();
  const { state } = useLocation();

  const { servico } = state;

  const handleContratarClick = ({ title, parcela, valorParcela }) => {
    if (title.includes('CARTÃO')) {
      history.push({
        pathname: '/PagamentoComCartao',
        state: {
          type: 'SERVICO',
          isOpeningCompany: false,
          plano: {
            ...servico,
            parcela,
            valorParcela,
          },
        },
      });
    } else {
      history.push({
        pathname: '/PagamentoComBoleto',
        state: {
          type: 'SERVIÇOS',
          plano: {
            ...servico,
            parcela,
            valorParcela,
          },
        },
      });
    }
  };

  return (
    <Box className={classes.root}>
      <Card variant="outlined">
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            Formas de pagamento
          </Typography>
        </CardContent>
        <List className={classes.list}>
          {servico.servico_forma_pagamento?.length > 0 &&
            servico.servico_forma_pagamento.map(
              ({ id, forma_de_pagamento }) => (
                <PaymentItem
                  key={id}
                  formaPagamento={forma_de_pagamento}
                  valor={servico.valor}
                  onClick={handleContratarClick}
                />
              )
            )}
        </List>
      </Card>
    </Box>
  );
}

export default FormasPagamento;
